/**
 * Labstep
 *
 * @module components/EntityExport/Table
 * @desc A table displaying EntityExports
 */

import { LogBreadcrumb } from 'labstep-web/components/Log/Breadcrumb';
import { Flex } from 'labstep-web/core/Flex';
import { TableSimple } from 'labstep-web/core/Table/Simple';
import { EntityExport } from 'labstep-web/models/entity-export.model';
import { humanReadableDate } from 'labstep-web/services/date.service';
import type React from 'react';
import type { EntityExportTableProps } from './types';

export const EntityExportTable: React.FC<EntityExportTableProps> = ({
  entityExports,
}) => {
  const columns = [
    {
      header: 'Date',
      content: (entityExport: EntityExport) =>
        humanReadableDate(entityExport.created_at),
      cellProps: { style: { width: 150 } },
    },
    {
      header: 'Type',
      content: (entityExport: EntityExport) =>
        entityExport.type.toUpperCase(),
      cellProps: { style: { width: 150 } },
    },
    {
      header: 'Entity',
      content: (entityExport: EntityExport) =>
        entityExport.log_create ? (
          <LogBreadcrumb
            log={entityExport.log_create}
            entityName={EntityExport.entityName}
            showGroup
          />
        ) : null,
      cellProps: { flex: 2 },
    },

    {
      header: 'User',
      content: (entityExport: EntityExport) => (
        <Flex>
          {entityExport.author.name}
          {entityExport?.log_create?.clientIp
            ? ` (${entityExport.log_create.clientIp})`
            : entityExport.log_entry_create
              ? entityExport.log_entry_create.client_ip
              : ''}{' '}
          {entityExport.log_create || entityExport.log_entry_create
            ? `${entityExport.clientDisplayLabel}`
            : ''}
        </Flex>
      ),
      cellProps: { flex: 1 },
    },
  ];
  return <TableSimple rows={entityExports} columns={columns} />;
};
